@if (items().length > 0) {
  <div class="ui-invoice-subtotal-check">
    <div class="ui-invoice-subtotal-check__row">
      <span class="ui-invoice-subtotal-check__label">{{ countLabel() }}</span>
      <span class="ui-invoice-subtotal-check__value">{{ subtotalText() }}</span>
    </div>
    <ui-tag
      [label]="matches() ? 'Subtotal coincide' : 'Subtotal no coincide'"
      [color]="matches() ? 'success' : 'danger'"
    />
  </div>
}
